module.exports = __webpack_public_path__ + "img/content_l.b148f237.png";